/**
 * Subject presentation helpers.
 *
 * `subjectColour` maps a subject code to one of six `--subject-N` tokens, so
 * a subject keeps the same colour on every page and in every session. Used
 * only as a 3px lesson edge or a small swatch, never as a fill.
 * `subjectName` turns `computer-science` into `Computer Science`.
 */

const SLOTS = 6;

const PINNED: Record<string, number> = {
  maths: 1,
  physics: 2,
  "computer-science": 3,
  english: 4,
  chemistry: 5,
  biology: 6,
  science: 6,
  french: 4,
  spanish: 5,
  german: 2,
  history: 3,
  geography: 6,
};

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function subjectColour(code: string | undefined | null): string {
  if (!code) return "var(--color-warm-cream-500)";
  const key = code.toLowerCase();
  const slot = PINNED[key] ?? (hash(key) % SLOTS) + 1;
  return `var(--subject-${slot})`;
}

export function subjectName(code: string | undefined | null): string {
  if (!code) return "";
  if (code.toLowerCase() === "pe") return "PE";
  return code
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

/** `year-10` to `Year 10`, `reception` to `Reception`. */
export function yearGroupName(code: string | undefined | null): string {
  if (!code) return "";
  return subjectName(code);
}
